module.exports = __webpack_public_path__ + "e04a291d21cd3ed7fda21902a3882e83.png";